import React from "react";
import { NavLink } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useFetch, useLanguage, usePagination } from "hooks";
import { Layout, Pagination, Skeletons } from "components";
import Nav from "../Nav";
import { STORAGE_URL } from "constants";

/**
 * history page in profile that display user history (information resource user that enter)
 * show data in list
 */

export default function History() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { page } = usePagination();
  const [historyResponse, historyRequest] = useFetch(`User/getUserHistory`); // information resource user that enter
  const BookRowItem = ({
    id,
    name,
    subtitle,
    image,
    date,
    renderSeperator,
  }) => (
    <div className="">
      <Row className="align-items-center px-5">
        <Col xl={8} lg={7} md={12} sm={12} xs={12}>
          <Row className="align-items-center">
            <Col xl={2} lg={2} md={3} sm={3} xs={3}>
              <NavLink to={`/book/${id}`}>
                <img
                  src={`${STORAGE_URL}${image}`}
                  alt="Book"
                  className="w-100"
                />
              </NavLink>
            </Col>
            <Col xl={10} lg={10} md={9} sm={9} xs={9}>
              <Row>
                <Col xs={12}>
                  <NavLink to={`/book/${id}`}>
                    <h6 className="fw-bold text-black cut-text-1">{name}</h6>
                  </NavLink>
                </Col>
                <Col xs={12}>
                  <small className="fw-normal text-light4 cut-text-1">
                    {subtitle}
                  </small>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col xl={4} lg={5} md={12} sm={12} xs={12}>
          {date && (
            <Row className="align-items-center mt-4 mt-md-0">
              <Col xl={5} lg={5} md={5} sm={5} xs={5}>
                <p className="text-light4">{language.viewHistory}</p>
              </Col>
              <Col xl={7} lg={7} md={7} sm={7} xs={7}>
                <p>{date}</p>
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      {renderSeperator && <hr className="my-4 bg-light3" />}
    </div>
  );/* show a single item ( information resource ) */

  React.useEffect(() => {
    historyRequest(null, `?page=${page}`);
  }, [historyRequest, page]);

  return (
    <Layout>
      <section id="profile" className="mb-3">
        <Container>
          <Row>
            <Col xs={12}>
              <h1 className="text-primary fw-bold cut-text-1">
                {language.history}
              </h1>
            </Col>
          </Row>

          <Row className="mt-4 mt-4 mt-4 ">
            {/* Right */}
            <Col xl={3} lg={3} md={4} sm={12} xs={12}>
              <Nav />
            </Col>

            {/* Left */}
            <Col
              xl={9}
              lg={9}
              md={8}
              sm={12}
              xs={12}
              className="mt-4 mt-4 mt-4  mt-md-0"
            >
              {historyResponse.loading ? (
                <Row className="bg-white rounded py-3">
                  <Skeletons.HorizontalCardSkeleton />
                </Row>
              ) : historyResponse.result.data?.length > 0 ? (
                <Row className="bg-white rounded py-3">
                  {historyResponse.result.data.map((item, index) => (
                    <Col xs={12} key={index}>
                      <BookRowItem
                        id={item.id}
                        name={item.name}
                        subtitle={item.sub_title}
                        image={item.cover_image}
                        date=""
                        renderSeperator={
                          index < historyResponse.result.data.length - 1
                        }
                      />
                    </Col> /* show a single item ( information resource ) */
                  ))}
                </Row>
              ) : (
                <Row className="justify-content-center">
                  <Col md={6} xs={12}>
                    <img
                      className="not-found w-100"
                      src={"/images/Reading glasses-pana.svg"}
                      alt="Not Found"
                    />{" "}
                    {/* Not Found image */}
                  </Col>
                </Row>
              )}
            </Col>
            <Col xl={3} lg={3} md={4} sm={12} xs={12}></Col>
            <Col xl={9} lg={9} md={8} sm={12} xs={12} className="mt-4">
              {!historyResponse.loading &&
                historyResponse.result.data &&
                historyResponse.result.meta && (
                  <Pagination
                    count={historyResponse.result.meta.total}
                    perPage={historyResponse.result.meta.per_page}
                  /> // pagination
                )}
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  );
}